module.exports = __webpack_public_path__ + "img/pocket-tablet_cn.f5e3655.jpg";